import {
  type MutationFunction,
  type UseMutationOptions,
  useMutation,
} from "@tanstack/react-query";

import { toastError } from "@alpacahq/ui/old";

import { getErrorMessage } from ".";

export function useMutationRequest<T, U>(
  request: MutationFunction<T, U>,
  options?: Omit<UseMutationOptions<T, Error, U, unknown>, "mutationFn">,
) {
  const mutation = useMutation<T, Error, U>({
    mutationFn: request,
    onError: (e) => {
      const key = "errorToastKey";
      const message = getErrorMessage(e);
      toastError(message, {
        toastId: key,
        autoClose: 3000,
        position: "top-right",
      });
    },
    ...options,
  });

  return mutation;
}

export default useMutationRequest;
